import ENV from "../env";

/**
 * Create a customer from a public form (no authentication required)
 * Used by visitors who scan QR codes
 */
const createCustomerPublic = async (details) => {
  const response = await fetch(
    `${ENV.firebaseApiUrl}/publicCustomer/create-public`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        customer: details,
      }),
    }
  );

  const resData = await response.json();

  if (!response.ok) {
    throw new Error("Create customer failed: " + (resData.error || resData.message));
  }

  return resData.customerId;
};

export default createCustomerPublic;
